import http from "@/services/http";

export async function fetch() {
  const { data } = await http().get(globalThis.env.API_COMMERCE + "/countries");
  return data.countries;
}
